<template lang="pug">
modal(ref="modal", :loading="loading")
    template(slot="title") Add Product
    template(slot="body")
        .form-group
            label Select Product
            product-selector(
                :exclude-pricebook="pricebook.id",
                v-model="product",
                :disabled="loading",
                ref="productSelector"
            )

        div(v-if="product !== null")
            include pricebook-product-form
    template(slot="footer")
        button.btn.btn-fw.green(
            @click="submit",
            :disabled="loading || product === null"
        )
            v-loading(loader="save-pricebook-entry") Add

</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    data() {
        return {
            product: null,
        };
    },

    computed: {
        ...mapGetters('pricebook', ['pricebook']),

        loading() {
            return this.onLoading('save-pricebook-entry');
        },
    },

    watch: {
        product(p) {
            if (p !== null) {
                this.$set(p, 'hidden', false);

                if (p.price_type == 1) {
                    this.$set(p, 'override_unit_price', p.unit_price);
                } else if (p.price_type == 0) {
                    p.variants.forEach(v => {
                        this.$set(v, 'override_cost', v.cost);
                        this.$set(v, 'override_price', v.price);
                        this.$set(v, 'hidden', false);
                    });
                }
            }
        },
    },

    mounted() {
        this.$on('show', () => {
            this.product = null;
            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        ...mapActions('pricebook', ['saveProductVariantEntry']),

        async submit() {
            if (!(await this.$validator.validate())) return;

            try {
                await this.saveProductVariantEntry(this.product);
                this.$emit('entry-saved');
                this.$refs.productSelector.getData();
                this.product = null;
            } catch (e) {
                this.showApiError(e);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/pricebook/pricebook-add-product.vue